import { render, staticRenderFns } from "./FmuMediaTypes.vue?vue&type=template&id=038610f8&scoped=true&"
import script from "./FmuMediaTypes.vue?vue&type=script&lang=js&"
export * from "./FmuMediaTypes.vue?vue&type=script&lang=js&"
import style0 from "./FmuMediaTypes.vue?vue&type=style&index=0&id=038610f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038610f8",
  null
  
)

export default component.exports